const Contact = () => {

    return (
        <section id="contact" className="relative  bg-transparent h-screen w-full my-8 overflow-hidden">
        <div className="relative flex items-center h-1/6">

            <h1 className="relative flex items-center justify-center h-10 w-40 text-2xl text-white rounded-2xl p-4 my-2 bg-gradient-to-br from-customyellow to-customdarkblue ">Contact</h1>
        </div>

        <div className="relative flex justify-center items-center w-full h-3/6 overflow-x-hidden sm-max:h-4/6 sm-max:flex-col">
            <div  className="box-container flex items-center justify-center w-80 h-3/4 bg-transparent m-1 ">
                <div  className="cube">
                    <div className="side"></div>
                    <div className="side"></div>
                    <div className="side"></div>
                    <div className="side"></div>
                    <div className="side"></div>
                    <div className="side"></div>
                </div>
            </div>

            <a className=" relative h-20 w-40 mx-40 overflow-hidden flex justify-center items-center" href="mailto:pizares@yahoo.fr" >
                <img className="absolute inset-0 object-cover h-full w-full" src="envelope.svg" alt="envelope svg" /> 
                <span className="absolute top-2/3 left-1/4 text-white">Email me</span>
            </a>
            <div className="box-container flex items-center justify-center w-80 h-3/4 bg-transparent m-1 sm-max:hidden">
                <div  className="cube">
                    <div className="side"></div>
                    <div className="side"></div>
                    <div className="side"></div>
                    <div className="side"></div>
                    <div className="side"></div>
                    <div className="side"></div>
                </div>
            </div>

        </div>

        <div className="relative flex flex-col justify-center items-center w-full h-2/6 sm-max:h-1/6">
            <div id="contact-items-container-holder" className="absolute flex justify-center items-center w-1/2 h-full py-4 overflow-hidden bg-white rounded-2xl sm-max:w-full md-min:w-full">
                <div id="contact-items-container" className="flex flex-row w-full h-full">
                    <a className=" relative flex items-center flex-shrink-0  justify-center font-bold text-8xl text-gray-600 hover:text-customdarkblue focus:text-customyellow sm-max:text-4xl " href="https://www.linkedin.com/in/yanick-ndi-3b01a397/" target="_blank" rel="noopener noreferrer" title="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
                    <a className=" relative flex items-center flex-shrink-0  justify-center font-bold text-8xl text-gray-600 hover:text-customdarkblue focus:text-customyellow sm-max:text-4xl " href="https://twitter.com/YanickNdi" target="_blank" rel="noopener noreferrer" title="Twitter"><i className="fab fa-twitter"></i></a>
                    <a className=" relative flex items-center flex-shrink-0  justify-center font-bold text-8xl text-gray-600 hover:text-customdarkblue focus:text-customyellow sm-max:text-4xl " href="https://codepen.io/yanick-web" target="_blank" rel="noopener noreferrer" title="Codepen"><i className="fab fa-codepen"></i></a>
                    <a className=" relative flex items-center flex-shrink-0  justify-center font-bold text-8xl text-gray-600 hover:text-customdarkblue focus:text-customyellow sm-max:text-4xl " href="https://github.com/Yanick-web" target="_blank" rel="noopener noreferrer" title="Github"><i className="fab fa-github-alt"></i></a>

                    
                </div>
            </div>
        </div>
        </section>
    );
};


export default Contact;